import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { MessageService } from "primeng/api";
import {
  AsReportedSecurityBreakdownTags,
  InsiderTradingPlans,
  InsiderTradingPlansFilters,
  IssuerTradingPlansFilters,
  IssuerWithInsiderTradingPlans,
} from "src/api/models";
import {
  InsiderTradingPlansService,
  InsiderViewTradingPlansService,
  IssuerTradingPlansService,
} from "src/api/services";
import {
  preventLeadingSpaceKey,
  handlePasteWithoutLeadingSpaces,
} from "../../../core/utils/input-validation.utils";
@Component({
  selector: "app-insider-details",
  templateUrl: "./insider-details.component.html",
  styleUrls: ["./insider-details.component.css"],
  standalone: false,
})
export class InsiderDetailsComponent implements OnInit {
  @ViewChild("scrollContainer") scrollContainer!: ElementRef;
  first = 0;
  rows = 10;
  isLoading: boolean = false;
  filingDateFrom: Date | null = null;
  filingDateTo: Date | null = null;
  insiderName: any;
  issuerId: any;
  insiderId: any;

  issuerName: any;
  insiderTradingPlans: InsiderTradingPlans[] = [];
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  filteredPlans: any[] = [];
  isLastPage: boolean = false;
  selectedInsiders: any[] = [];
  selectedTags: any[] = [];
  planActions = [
    { label: "All", value: "" },
    { label: "Adoption", value: "adoption" },
    { label: "Termination", value: "termination" },
    { label: "Amendment", value: "amendment" },
  ];

  tags = [
    { label: "Sell to Cover", key: "sellToCover", disable: false },
    { label: "Award Related", key: "awardRelated", disable: false },
    { label: "Gift Related", key: "giftRelated", disable: false },
    { label: "Tax Withheld", key: "taxWithheld", disable: false },
    { label: "Remuneration", key: "remuneration", disable: false },
    { label: "Options Related", key: "optionsRelated", disable: false },
    { label: "is_indeterminable", key: "isIndeterminable", disable: false },
  ];

  filters: any = {
    filingId: "",
    issuerName: "",
    insider: "",
    action: "",
    tag: "",
    planAction: "",
    indeterminable: false,
    filingDateFrom: null,
    filingDateTo: null,
    includeIndeterminable: false,
    tradingPlanInDuplicateQualityGate: false,
  };
  isFiltersActive(): boolean {
    const f = this.filters;
    return !!(
      f.filingId ||
      f.issuerName ||
      f.insider ||
      f.action ||
      f.tag ||
      f.filingDateFrom ||
      f.filingDateTo ||
      f.indeterminable ||
      f.includeIndeterminable ||
      f.planAction ||
      f.tradingPlanInDuplicateQualityGate
    );
  }

  constructor(
    private route: ActivatedRoute,
    public insiderViewTradingPlansService: InsiderViewTradingPlansService,
    public issuerTradingPlansService: IssuerTradingPlansService,
    public _messageService: MessageService
  ) {}
  normalizeFilters() {
    Object.keys(this.filters).forEach((key) => {
      if (typeof this.filters[key] === "string") {
        this.filters[key] = this.filters[key].trim();
      }
    });
  }
  ngOnInit(): void {
    this.insiderName = this.route.snapshot.queryParamMap.get("insiderName");
    this.issuerId = this.route.snapshot.queryParamMap.get("issuerId");
    this.issuerName = this.route.snapshot.queryParamMap.get("issuerName");
    this.insiderId = this.route.snapshot.queryParamMap.get("insiderId");

    // if (this.insiderName) {
    //   console.log("insiderName", this.insiderName);
    //   this.getInsiderTradingPlans();
    // }
  }
  getBadgeClass(action: string): string {
    switch (action) {
      case "adoption":
        return "badge badge-adoption";
      case "termination":
        return "badge badge-termination";
      case "amendment":
        return "badge badge-amendment";
      default:
        return "";
    }
  }
  onExecute() {
    console.log("Execute triggered with:", this.filters);
  }
  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    if (this.scrollContainer?.nativeElement) {
      this.scrollContainer.nativeElement.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }
  loadData(event?: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;

    this.getInsiderTradingPlans();
  }
  getInsiderTradingPlans(isLoadMore: boolean = false): void {
    this.normalizeFilters();
    const params: IssuerTradingPlansFilters = {
      planAction: this.filters.planAction || undefined,
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      filingId: this.filters.filingId || undefined,
      issuerId: this.issuerId ? Number(this.issuerId) : undefined,
      insiderId: this.insiderId ? Number(this.insiderId) : undefined,
      insiderName: this.insiderName || undefined,
      isIndeterminable: this.filters.includeIndeterminable || undefined,
      tradingPlanInDuplicateQualityGate:
        this.filters.tradingPlanInDuplicateQualityGate || undefined,
      filingDateFrom: this.filters.filingDateFrom
        ? this.formatDateForBackend(this.filters.filingDateFrom)
        : undefined,
      filingDateTo: this.filters.filingDateTo
        ? this.formatDateForBackend(this.filters.filingDateTo)
        : undefined,
    };
    this.isLoading = true;

    this.insiderViewTradingPlansService
      .getInsiderViewTradingPlans(params)
      .subscribe({
        next: (value) => {
          this.insiderTradingPlans = value;
        },
        error: (err) => {
          this.isLoading = false;
          this._messageService.add({
            summary: err.error.message,
            severity: "error",
          });
        },
        complete: () => {
          const plans = this.insiderTradingPlans ?? [];
          this.paginator.totalCount =
            plans.length > 0 && plans[0].totalCount != null
              ? plans[0].totalCount
              : 0;

          this.isLoading = false;
        },
      });
  }

  onSubmitFilters(): void {
    this.paginator.pageNumber = 1;
    // this.issuerWithInsiderTradingPlans.insiderTradingPlans = [];
    this.selectedInsiders = [];
    this.getInsiderTradingPlans(false);
  }
  clearFilters() {
    this.filters = {
      filingId: "",
      issuerName: "",
      insider: "",
      action: "",
      tag: "",
      indeterminable: false,
      filingDateFrom: null,
      filingDateTo: null,
      includeIndeterminable: false,
      planAction: "",
      tradingPlanInDuplicateQualityGate: false,
    };
    this.selectedTags = [];
    this.onSubmitFilters();
  }
  formatDateForBackend(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  onApplyTags() {
    if (!this.selectedInsiders.length) {
      this._messageService.add({
        severity: "warn",
        summary: "Please select at least one insider to apply tags.",
      });
      return;
    }

    const securityBreakDownTags: AsReportedSecurityBreakdownTags = {
      awardRelated: false,
      giftRelated: false,
      isIndeterminable: this.filters.indeterminable ? true : false,
      modified: false,
      optionsRelated: false,
      remuneration: false,
      sellToCover: false,
      taxWithheld: false,
    };

    this.selectedTags.forEach((tag) => {
      if (tag.key in securityBreakDownTags) {
        (securityBreakDownTags as any)[tag.key] = true;
      }
    });

    const payload = {
      asReportedSecurityBreakdownIds: this.selectedInsiders.map(
        (i) => i.asReportedSecurityBreakdownId
      ),
      securityBreakdownTags: securityBreakDownTags,
    };

    console.log("Applying Tags with payload:", payload);

    this.isLoading = true;
    this.issuerTradingPlansService
      .updateSecurityBreakdownTags(payload)
      .subscribe({
        next: (response) => {
          if (response) {
            this._messageService.add({
              severity: "success",
              summary: "Tags applied successfully!",
            });
          } else {
            this._messageService.add({
              severity: "error",
              summary: "Failed to apply tags.",
            });
          }
        },
        error: (err) => {
          console.error("Error:", err);
          this._messageService.add({
            severity: "error",
            summary: "Something went wrong while applying tags.",
          });
          this.isLoading = false;
          this.clearFilters();
        },
        complete: () => {
          this.isLoading = false;
          this.clearFilters();
        },
      });
  }

  getStringForTransactionTags(securityBreakDownTags: string | null): string[] {
    if (!securityBreakDownTags) return [];

    const map: Record<string, string> = {
      awardRelated: "A",
      optionsRelated: "O",
      giftRelated: "G",
      taxWithheld: "T",
      remuneration: "R",
      isIndeterminable: "I",
      sellToCover: "S",
    };

    return securityBreakDownTags
      .split(",")
      .map((tag) => map[tag.trim()])
      .filter(Boolean);
  }

  onTagSelection() {
    this.tags.forEach((tag) => (tag.disable = false));

    this.selectedTags.forEach((sel) => {
      if (sel.key === "remuneration" || sel.key === "giftRelated") {
        this.tags.forEach((tag) => {
          if (tag.key !== sel.key) tag.disable = true;
        });
        this.selectedTags = [sel];
      } else if (sel.key === "optionsRelated") {
        this.tags.forEach((tag) => {
          if (tag.key === "awardRelated") tag.disable = true;
        });
        this.selectedTags = this.selectedTags.filter(
          (t) => t.key !== "awardRelated"
        );
      } else if (sel.key === "awardRelated") {
        this.tags.forEach((tag) => {
          if (tag.key === "optionsRelated") tag.disable = true;
        });
        this.selectedTags = this.selectedTags.filter(
          (t) => t.key !== "optionsRelated"
        );
      }
    });

    this.filters.tag =
      this.selectedTags.length > 0
        ? this.selectedTags.map((tag) => tag.key).join(",")
        : "";

    const disabledCount = this.tags.filter((tag) => tag.disable).length;
    console.log("Disabled tags count:", disabledCount);
    console.log("filters.tag:", this.filters.tag);
  }
  onSelectionChange(event: any) {
    // if selected tags more than 1 clear the tags
    if (this.selectedInsiders.length > 1) {
      this.selectedTags = [];
      this.tags.forEach((t) => (t.disable = false));
      this.filters.tag = "";
      return;
    }
    const allSelectedTags: Set<string> = new Set();

    this.selectedInsiders.forEach((row) => {
      if (row.asReportedSecurityBreakdownTags) {
        row.asReportedSecurityBreakdownTags
          .split(",")
          .map((t: string) => t.trim())
          .forEach((tag: any) => allSelectedTags.add(tag));
      }
    });

    this.selectedTags = this.tags.filter((tag) => allSelectedTags.has(tag.key));
    this.onTagSelection();
    console.log("Combined Selected Tags:", this.selectedTags);
  }
  preventSpaceKey(event: KeyboardEvent): void {
    // Use generic utility function to prevent leading spaces
    preventLeadingSpaceKey(event);
  }

  onPaste(event: ClipboardEvent): void {
    // Use generic utility function to handle paste without leading spaces
    handlePasteWithoutLeadingSpaces(event, (newValue: string) => {
      this.filters.filingId = newValue;
    });
  }
}
